import { useParallax } from '@/hooks/useParallax';

export default function Hero() {
  const parallaxRef = useParallax(0.25);

  return (
    <section
      ref={parallaxRef}
      id="accueil"
      className="min-h-[100dvh] sm:min-h-[100dvh] flex items-center justify-center relative overflow-hidden"
    >
      {/* Image de fond + overlay isolés en arrière-plan */}
      <div className="absolute inset-0 z-0 animate-hero-zoom">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage:
              "url('https://storage.readdy-site.link/project_files/d8db5950-dd7c-40d9-b2de-72ddcdf21388/59050592-413d-4d92-847c-339f22bb6ea9_image_fond_site.png?v=ce18c8ce767b097e29da5746a4dbe778')",
            imageRendering: '-webkit-optimize-contrast',
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/10 via-white/15 to-white/10 sm:from-white/20 sm:via-white/30 sm:to-white/20" />
      </div>

      {/* Contenu au premier plan */}
      <div className="w-full max-w-7xl mx-auto px-2 sm:px-6 lg:px-8 relative z-20 py-6 sm:py-12 md:pt-14 lg:pt-16 xl:pt-20 pb-6 sm:pb-12 lg:pb-10 xl:pb-12">
        <div className="text-center flex flex-col items-center mt-8 sm:mt-0">

          {/* Titre principal dominant */}
          <h1
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 sm:mb-4 lg:mb-7 xl:mb-9 px-2 animate-fade-in-up delay-200 leading-tight"
            style={{ textShadow: '0 3px 20px rgba(0,0,0,0.7)' }}
          >
            UNE SOLUTION CLÉ EN MAIN POUR UN BAR PERFORMANT
          </h1>

          {/* Badges percutants */}
          <div className="flex flex-row gap-1 sm:gap-3 w-full max-w-2xl mx-auto mt-3 sm:mt-0 mb-4 sm:mb-8 lg:mb-8 xl:mb-10 animate-fade-in-up delay-400">
            <div className="flex-1 flex items-center justify-center gap-1 sm:gap-3 bg-black/40 backdrop-blur-lg border border-white/30 rounded-full px-2 py-1 sm:px-5 sm:py-2.5">
              <div className="w-3 h-3 sm:w-4 sm:h-4 flex items-center justify-center flex-shrink-0">
                <i className="ri-time-line text-[#00A8B5] text-[10px] sm:text-sm"></i>
              </div>
              <span
                className="font-extrabold text-[10px] sm:text-base text-[#00A8B5] text-center leading-tight tracking-wide whitespace-nowrap"
                style={{ textShadow: '0 2px 12px rgba(0,0,0,0.6)' }}
              >
                DÉPLOYÉ EN <span className="text-xs sm:text-lg">15</span> MINUTES
              </span>
            </div>
            <div className="flex-1 flex items-center justify-center gap-1 sm:gap-3 bg-black/40 backdrop-blur-lg border border-white/30 rounded-full px-2 py-1 sm:px-5 sm:py-2.5">
              <div className="w-3 h-3 sm:w-4 sm:h-4 flex items-center justify-center flex-shrink-0">
                <i className="ri-dashboard-3-line text-[#00A8B5] text-[10px] sm:text-sm"></i>
              </div>
              <span
                className="font-extrabold text-[10px] sm:text-base text-[#00A8B5] text-center leading-tight tracking-wide whitespace-nowrap"
                style={{ textShadow: '0 2px 12px rgba(0,0,0,0.6)' }}
              >
                JUSQU&apos;À <span className="text-xs sm:text-lg">1000</span> BIÈRES / HEURE
              </span>
            </div>
          </div>

          {/* Boutons CTA */}
          <div className="flex flex-row gap-2 sm:gap-6 justify-center mb-5 sm:mb-10 lg:mb-10 xl:mb-12 px-2 sm:px-4 animate-fade-in-up delay-500">
            <a
              href="#devis"
              className="flex-1 sm:flex-none bg-[#00A8B5] hover:bg-[#008f9b] text-black font-extrabold px-4 sm:px-16 py-3 sm:py-5 rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer text-center text-xs sm:text-lg shadow-lg hover:shadow-2xl hover:-translate-y-1 flex items-center justify-center gap-2 animate-cta-pulse"
            >
              <span>Louez-moi</span>
              <div className="hidden sm:flex w-4 h-4 sm:w-5 sm:h-5 items-center justify-center">
                <i className="ri-arrow-right-line text-sm sm:text-lg"></i>
              </div>
            </a>
            <a
              href="#remorque"
              className="flex-1 sm:flex-none bg-[#00A8B5] hover:bg-[#008f9b] text-black font-extrabold px-4 sm:px-16 py-3 sm:py-5 rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer text-center text-xs sm:text-lg shadow-lg hover:shadow-2xl hover:-translate-y-1 flex items-center justify-center gap-2"
            >
              <span>Découvrir la remorque</span>
              <div className="hidden sm:flex w-4 h-4 sm:w-5 sm:h-5 items-center justify-center">
                <i className="ri-arrow-down-line text-sm sm:text-lg"></i>
              </div>
            </a>
          </div>

          {/* Features */}
          <div className="flex flex-row flex-wrap gap-3 sm:gap-6 lg:gap-5 xl:gap-7 items-center justify-center px-2 sm:px-4 mb-4 sm:mb-6 lg:mb-8 animate-fade-in-up delay-700">
            <div className="flex items-center space-x-2">
              <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center">
                <i className="ri-flashlight-line text-[#00A8B5] text-sm sm:text-base"></i>
              </div>
              <span className="text-xs sm:text-sm font-medium text-white/90">Double débit</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center">
                <i className="ri-group-line text-[#00A8B5] text-sm sm:text-base"></i>
              </div>
              <span className="text-xs sm:text-sm font-medium text-white/90">Optimisé pour les fortes affluences</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center">
                <i className="ri-palette-line text-[#00A8B5] text-sm sm:text-base"></i>
              </div>
              <span className="text-xs sm:text-sm font-medium text-white/90">Branding personnalisé</span>
            </div>
          </div>

          {/* Sous-titre */}
          <div className="mt-4 sm:mt-8 lg:mt-10 xl:mt-12 bg-black/40 backdrop-blur-lg border border-white/20 rounded-2xl sm:rounded-full px-2 sm:px-6 py-2 sm:py-2.5 animate-fade-in-up delay-800 block w-full sm:w-auto sm:inline-block text-center">
            <p
              className="text-[10px] sm:text-sm md:text-base lg:text-lg text-white font-bold leading-snug whitespace-nowrap"
              style={{ textShadow: '0 2px 16px rgba(0,0,0,0.8)' }}
            >
              La remorque-bar professionnelle pensée par des experts du terrain
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}
